/**
 * Not intended for external use.
 * A constant that can be passed to `useStore` to indicate that the consumer
 * wishes to subscribe to, and be able to read, every field of the context
 * store and not just those fields that are explicitly listed in an array.
 * This isn't meant to be used directly; use `useAllFieldsOfContextStore` instead.
 */ export var ALL_FIELDS_MARKER = Symbol("ALL_FIELDS_MARKER");
